/**
 * DefaultFieldValue
 */
import React from 'react';
import { connect } from 'react-redux';
import { change } from 'redux-form';

interface Props {
    change: Function;
    name: string;
    value: ?string;
    formName: string;
}

export class DefaultFieldValue extends React.PureComponent<Props> {
    componentDidMount() {
        const { name, value, formName } = this.props;
        this.props.change(formName, name, value);
    }

    render() {
        return null;
    }
}

export default connect(
    null,
    { change }
)(DefaultFieldValue);
